import React from 'react';
import App from './App';
import './index.css';
import { createRoot } from 'react-dom/client';

const container = document.getElementById('root');
const root = createRoot(container!);

if (
  window.location.protocol === 'http:' &&
  window.location.hostname !== 'localhost'
) {
  window.location.href = window.location.href.replace('http:', 'https:');
}

root.render(
  //<React.StrictMode>
    <App />
  //</React.StrictMode>
)
